import { MapperFactory } from '@products/utils/mappers/mapper-factory';
import { Mapper, MapperParams } from '@products/utils/mappers/type.mapper';
import { IndexesDTO } from '../dto/indexes.dto.types';
import { Indexes } from '../model/indexes';
import { IndexAssetAllocationsMapper } from './index-asset-allocations';
import { IndexCustomPerformanceMapper } from './index-custom-performance.type.mapper';
import { IndexLevelsMapper } from './index-levels.type.mapper';
import { IndexPerformanceMapper } from './index-performance.type.mapper';

export class IndexesMapper extends Mapper<Indexes> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(indexesDTO: IndexesDTO): Indexes {
    return {
      indexPerformance: indexesDTO.indexperformance
        ? this.createMapper(IndexPerformanceMapper).toDomain(
            indexesDTO.indexperformance
          )
        : null,
      indexLevels: indexesDTO.indexlevels
        ? this.createMapper(IndexLevelsMapper).toDomain(indexesDTO.indexlevels)
        : null,
      indexAssetAllocations: indexesDTO.indexassetallocation
        ? this.createMapper(IndexAssetAllocationsMapper).toDomain(
            indexesDTO.indexassetallocation
          )
        : null,
      indexCustomPerformance: indexesDTO.indexcustomperformance
        ? this.createMapper(IndexCustomPerformanceMapper).toDomain(
            indexesDTO.indexcustomperformance
          )
        : null,
    };
  }
}
